import { ref } from 'vue';

export function inputComposable() {
    const variant = ref('underlined');
    const density = ref('compact');
    return {
        variant,
        density,
    };
}